import { render, staticRenderFns } from "./FunctionUpgrade.vue?vue&type=template&id=55e3cc49&scoped=true&"
import script from "./FunctionUpgrade.vue?vue&type=script&lang=js&"
export * from "./FunctionUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./FunctionUpgrade.vue?vue&type=style&index=0&id=55e3cc49&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3cc49",
  null
  
)

export default component.exports